"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var InitialLoaderShelf_1 = require("./InitialLoaderShelf");
var LoaderShelf_1 = require("./LoaderShelf");
var PaginatedListShelf = /** @class */ (function () {
    function PaginatedListShelf(getItems, fetchOptions) {
        var _this = this;
        this.loader = new LoaderShelf_1.default();
        this.initialLoader = new InitialLoaderShelf_1.default();
        this.page = 0;
        this.itemsPerPage = 20;
        this.items = [];
        this.error = null;
        this.hasNextPage = false;
        this.fetchPage = function (page) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newItems, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (page < 0) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loader.tryStart("Cannot fetch again. The last fetch still loading.");
                        return [4 /*yield*/, this.getItems(page)];
                    case 2:
                        newItems = _a.sent();
                        this.afterFetch(newItems, page);
                        if (this._onModelFetch) {
                            this._onModelFetch(newItems);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.setError(e_1);
                        if (this._onModelFetchError) {
                            this._onModelFetchError(e_1);
                        }
                        throw e_1;
                    case 4:
                        this.initialLoader.done();
                        this.loader.end();
                        return [7 /*endfinally*/];
                    case 5:
                        if (this._onFinishFetch) {
                            this._onFinishFetch();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.afterFetch = function (newItems, page) {
            _this.hasNextPage = newItems.length === _this.itemsPerPage;
            _this.items = newItems;
            _this.page = page;
        };
        this.refresh = function () {
            _this.fetchPage(_this.page);
        };
        this.clear = function () {
            _this.items = [];
            _this.error = null;
        };
        this.setError = function (error) {
            _this.error = error.message || "error";
        };
        this.nextPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.fetchPage(this.page + 1)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.previousPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.fetchPage(this.page - 1)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.getItems = getItems;
        if (fetchOptions) {
            if (fetchOptions.itemsPerPage) {
                this.itemsPerPage = fetchOptions.itemsPerPage;
            }
            this._onModelFetch = fetchOptions.onModelFetch;
            this._onModelFetchError = fetchOptions.onModelFetchError;
            this._onFinishFetch = fetchOptions.onFinishFetch;
        }
        mobx_1.makeAutoObservable(this);
    }
    return PaginatedListShelf;
}());
exports.default = PaginatedListShelf;
